const types = {
    trainee: {
        screens: []
    },
    supervisor: {
        routes: [ '/dashboard/cohort' ]
    },
    admin: {}
}

const Permission = (user, route) => {
    types[user.accessLevel]
}

export default Permission